import { NativeModulesProxy, EventEmitter, Subscription } from 'expo-modules-core';

// Import the native module. On web, it will be resolved to SimpleStorage.web.ts
// and on native platforms to SimpleStorage.ts
import SimpleStorageModule from './SimpleStorageModule';

export function getItem(keyName: string): string {
  return SimpleStorageModule.getItem(keyName);
}

export function setItem(keyName: string, value: string): void {
  SimpleStorageModule.setItem(keyName, value);
}
